<template>
<transition name="fade-loader" :appear="!initial" @afterLeave="handleLeave">
  <div class="ninja-loader"
    :class="{
      'ninja-loader--fullscreen': fullscreen,
      'ninja-loader--initial': initial,
      'ninja-loader--transparent': transparent,
    }"
    v-if="show"
    :style="fullscreenStyle"
    @touchstart.prevent.stop
    @mousedown.prevent.stop
    @mousewheel.prevent.stop>
    <div class="ninja-loader--animation">
      <div class="ninja-loader--animation--ball" v-for="i in 9" :key="`ball${i}`" />
    </div>
  </div>
</transition>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ninja-loader',
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true,
    },
    initial: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    /**
     * If the loader is fullscreen, it needs to resize to the parent window
     *
     * TODO: mixin so that the same idea can be used for modal bkg
     *
     * @returns {*}
     */
    fullscreenStyle() {
      if (!this.fullscreen) {
        return null;
      }

      return {
        top: `${this.scrollTop}px`,
        height: `${this.viewportHeight}px`,
      };
    },
    // showLoader () {
    //   return true
    //   // return this.show
    // },
    ...mapState('windowMedia', ['scrollTop']),
    ...mapGetters('windowMedia', ['viewportHeight'])
  },
  methods: {
    /**
     * Emit closed so that the loader can be removed after animating out.
     */
    handleLeave() {
      this.$emit('closed');
    },
  },
};
</script>

<style lang="scss">
.ninja-loader {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: $z-index-loader;

  background: $color-background-ninja-loader;
  &--initial {
    background: $color-background-ninja-loader-initial;
  }

  &--fullscreen {
    position: fixed;
    bottom: unset;
    right: unset;
    width: 100%;
  }

  &--transparent {
    background: transparent;
  }

  $animationDuration: 2.5s;
  &--animation {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -5.6rem;
    margin-top: -5.6rem;
    width: 11.3rem;
    height: 11.3rem;
    // background: red;
    transform-origin: center center;
    animation: rotate infinite $animationDuration ease-in-out;

    @keyframes rotate {
      0% {
        transform: rotate(0deg);
      }
      20% {
        transform: rotate(45deg);
      }
      60%, 100% {
        transform: rotate(45deg);
      }
    }

    &--ball {
      position: absolute;
      top: 0;
      left: 0;
      width: 2.6rem;
      height: 2.6rem;
      background: $color-base-ninja-yellow-base;
      border-radius: 1.3rem;

      @for $i from 1 through 9 {
        $position: $i - 1;
        $animationName: #{animation-ball-#{$i}};

        $scale: scale(1);
        $finalScale: scale(0.67);
        @if ($i % 2 == 0) {
          $scale: scale(0.67);
          $finalScale: scale(1);
        }

        &:nth-child(#{$i}) {
          left: (floor($position / 3) * 43px);
          top: (($position % 3) * 43px);

          @if ($i != 5) {
            animation: $animationName infinite $animationDuration ease-in-out;
          }

          transform: $scale;


          $xPositions: (1.9rem, -1.7rem, 1.9rem, 0, 0, 0, -1.9rem, 1.7rem, -1.9rem);
          $yPositions: (1.9rem, 0, -1.9rem, -1.7rem, 0, 1.7rem, 1.9rem, 0, -1.9rem);

          @keyframes #{$animationName} {
            0% {
              transform: #{$scale} translate3d(0, 0, 0);
            }
            40% {
              transform: #{$scale} translate3d(0, 0, 0);
            }
            60%, 100% {
              transform: #{$finalScale} translate3d(nth($xPositions, $i), nth($yPositions, $i), 0);
            }
          }
        }
      }
    }
  }
}
</style>
